(function () {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReduced && 'IntersectionObserver' in window) {
        var revealTargets = document.querySelectorAll('#MainContent .shopify-section');
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('cr-in-view');
                    observer.unobserve(entry.target);

                }
            })
        }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' })
        revealTargets.forEach(function (el) {
        el.classList.add('cr-reveal');
        observer.observe(el);
        });
    }

    var faqItems = document.querySelectorAll('.cr-faq-item');
    faqItems.forEach(function (item) {
        var summary = item.querySelector('summary');
        var answer = item.querySelector('.cr-faq-answer');
        if (!summary || !answer) return;

        answer.style.overflow = 'hidden';
        answer.style.transition = 'max-height .35s ease, opacity .35s ease';
        if (!item.open) {
            answer.style.maxHeight = '0px';
            answer.style.opacity = '0';

        } else {
        answer.style.maxHeight = 'none';
        answer.style.opacity = '1';
        }
        summary.addEventListener('click', function (event) {
            event.preventDefault();
            if (item.open) {
                var currentHeight = answer.scrollHeight;
                answer.style.maxHeight = currentHeight + 'px';
                requestAnimationFrame(function () {
                    answer.style.maxHeight = '0px';
                    answer.style.opacity = '0';

                });
                answer.addEventListener('transitionend', function close() {
                item.open = false;
                answer.removeEventListener('transitionend', close);

            }, { once: true });
        } else {
            item.open = true;
            var targetHeight = answer.scrollHeight;
            answer.style.maxHeight = '0px';
            answer.style.opacity = '0';
            requestAnimationFrame(function () {
                answer.style.maxHeight = targetHeight + 'px';
                answer.style.opacity = '1';

            });
            answer.addEventListener('transitionend', function openDone() {
            answer.style.maxHeight = 'none';
            answer.removeEventListener('transitionend', openDone);

        }, { once: true });
    }
});
    });
})();